import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { defineComponent, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

interface Props {
  content: string;
}

export default defineComponent({
  template: html,
  components: {},
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  setup(props: Props) {
    // Injections
    const { t } = useI18n();

    // vars und computed
    const contentId = `more-less-content-${Math.random().toString(36).slice(2)}`;
    const contentRef = ref<HTMLElement | null>(null);
    const expanded = ref(false);
    const hasMoreContent = ref(false);
    let resizeObserver: ResizeObserver | null = null;

    // Prüft ob der Content über die erste (per CSS geclampte) Zeile hinausragt
    const checkOverflow = () => {
      const el = contentRef.value;
      if (!el) {
        return;
      }
      hasMoreContent.value = el.scrollHeight > el.clientHeight + 1;
    };

    const toggle = () => {
      expanded.value = !expanded.value;
    };

    watch(
      () => props.content,
      () => {
        expanded.value = false;
        nextTick(checkOverflow);
      },
    );

    onMounted(() => {
      checkOverflow();
      if (typeof ResizeObserver !== "undefined" && contentRef.value) {
        resizeObserver = new ResizeObserver(checkOverflow);
        resizeObserver.observe(contentRef.value);
      }
    });
    onBeforeUnmount(() => {
      resizeObserver?.disconnect();
    });

    return {
      t,
      contentId,
      contentRef,
      expanded,
      hasMoreContent,
      toggle,
    };
  },
});
